// Capture API client (quick inbox). Mirrors FinanceService's auth pattern.
// PUT replaces the whole items array (the card mutates it then saves), like
// holdings. Payload is card-shaped (see CAPTURE in serga-os/data.js).

const API_BASE_URL = "https://api.serga.ba";

export interface CaptureItem {
  id: string;
  state: "inbox" | "note";
  at: string;
  route: string | null;
  text: string;
}

export interface CaptureView {
  schemaVersion?: number;
  items: CaptureItem[];
}

export class CaptureService {
  private static authTokens: any = null;

  static setAuthTokens(tokens: any) {
    this.authTokens = tokens;
  }

  private static getAuthHeaders() {
    if (!this.authTokens?.idToken) {
      throw new Error("No authentication token available");
    }
    return {
      Authorization: `Bearer ${this.authTokens.idToken}`,
      "Content-Type": "application/json",
    };
  }

  /** Inbox items, or null when nothing is stored yet (pending). */
  static async getCapture(): Promise<CaptureView | null> {
    const res = await fetch(`${API_BASE_URL}/capture`, { headers: this.getAuthHeaders() });
    if (!res.ok) throw new Error(`Request failed: ${res.status}`);
    const data = await res.json();
    if (!data || data.pending) return null;
    return data as CaptureView;
  }

  /** Replace the inbox. Returns the stored doc. */
  static async putCapture(items: CaptureItem[]): Promise<CaptureView> {
    const res = await fetch(`${API_BASE_URL}/capture`, {
      method: "PUT",
      headers: this.getAuthHeaders(),
      body: JSON.stringify({ items }),
    });
    if (!res.ok) {
      const text = await res.text();
      let msg = `Request failed: ${res.status}`;
      try {
        const p = JSON.parse(text);
        if (p.error) msg = p.error;
      } catch {}
      throw new Error(msg);
    }
    return res.json();
  }
}
